// showSuccess('Operation completed!');
// showError('Something went wrong!');
// showWarning('Please check your input');
// showInfo('Here\'s some information');

window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.notification = window.wpbuoy.notification || {};

let notificationContainer = null;
let notificationCounter = 0;

// Initialize the notification container
function initNotificationContainer() {
  if (notificationContainer) return;

  notificationContainer = document.createElement('div');
  notificationContainer.className = 'notification-container';
  document.body.appendChild(notificationContainer);
}

// Create and show a notification
export function showNotification(message, type = 'info', duration = 5000) {
  initNotificationContainer();

  const notification = document.createElement('div');
  const notificationId = `notification-${++notificationCounter}`;
  notification.id = notificationId;
  notification.className = `notification notification-${type}`;

  notification.innerHTML = `
    <div class="notification-inner">
      <span>${message}</span>
      <button type="button">&times;</button>
    </div>
  `;

  notificationContainer.appendChild(notification);

  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 10);

  // Close functionality
  const closeBtn = notification.querySelector('button');
  const closeNotification = () => {
    notification.style.transform = 'translateX(100%)';
    notification.style.opacity = '0';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  };

  closeBtn.addEventListener('click', closeNotification);
  notification.addEventListener('click', closeNotification);

  if (duration > 0) {
    setTimeout(closeNotification, duration);
  }

  return notificationId;
}

export function showSuccess(message, duration = 5000) {
  return showNotification(message, 'success', duration);
}

export function showError(message, duration = 7000) {
  return showNotification(message, 'error', duration);
}

export function showWarning(message, duration = 6000) {
  return showNotification(message, 'warning', duration);
}

export function showInfo(message, duration = 5000) {
  return showNotification(message, 'info', duration);
}

export function clearAllNotifications() {
  if (!notificationContainer) return;

  const notifications = notificationContainer.querySelectorAll('.notification');
  notifications.forEach(notification => {
    notification.style.transform = 'translateX(100%)';
    notification.style.opacity = '0';
  });

  setTimeout(() => {
    if (notificationContainer) {
      notificationContainer.innerHTML = '';
    }
  }, 300);
}

export function removeNotification(notificationId) {
  const notification = document.getElementById(notificationId);
  if (notification) {
    notification.style.transform = 'translateX(100%)';
    notification.style.opacity = '0';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }
}
